import { Spin } from 'antd';
import React, { Suspense, lazy } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import AuthGuard from './auth-guard';

// eslint-disable-next-line @typescript-eslint/no-explicit-any, react/display-name
const Loadable = (Component: any) => (props: any) => {
  return (
    <Suspense fallback={<Spin />}>
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {
  return useRoutes([
    {
      path: '/auth/login',
      element: <Login />,
    },
    {
      path: 'dashboard',
      element: (
        <AuthGuard>
          <AppLayout />
        </AuthGuard>
      ),
      children: [
        {
          index: true,
          element: <Navigate to="/dashboard/access" />,
        },
        {
          path: 'access',
          element: <AccessManagement />,
        },
        {
          path: 'modules',
          element: <ModuleManagement />,
        },
        {
          path: 'accounts',
          element: <AccountManagement />,
        },
        {
          path: 'roles',
          element: <RoleManagement />,
        },
        {
          path: 'logs',
          element: <LogManagement />,
        },
        {
          path: 'departments',
          element: <DepartmentManagement />,
        },
      ],
    },
    {
      path: 'account',
      element: (
        <AuthGuard>
          <AppLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: 'password',
          element: <ChangePasswordPage />,
        },
      ],
    },
    {
      path: '/',
      //   element: <AppLayout />,
      children: [
        {
          index: true,
          element: <Navigate to="/auth/login" replace />,
        },
      ],
    },
    {
      path: '/forget',
      element: <ResetPasswordPage />,
    },
  ]);
}

const Login = Loadable(lazy(() => import('@app/pages/LoginPage')));

const AppLayout = Loadable(lazy(() => import('@app/components/app-layout')));

const AccessManagement = Loadable(
  lazy(() => import('@admin/manage-access/pages/AccessPage')),
);

const ModuleManagement = Loadable(
  lazy(() => import('@admin/manage-module/pages/ModulePage')),
);

const AccountManagement = Loadable(
  lazy(() => import('@admin/manage-customer/pages/UserPage')),
);

const RoleManagement = Loadable(
  lazy(() => import('@admin/manage-role/pages/RolePage')),
);

const LogManagement = Loadable(
  lazy(() => import('@admin/manage-log/pages/LogPage')),
);

const DepartmentManagement = Loadable(
  lazy(() => import('@admin/manage-department/pages/DepartmentPage')),
);

const ChangePasswordPage = Loadable(
  lazy(() => import('@app/pages/change-password')),
);

const ResetPasswordPage = Loadable(
  lazy(() => import('@app/pages/forgot-password')),
);
